/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const StoreCreatePage = lazyLoad(
  () => import('./index'),
  module => module.StoreCreatePage
);
